export default __webpack_public_path__ + "static/media/EXTC.8c390986.jpg";